import React from 'react'
import { observer } from 'mobx-react'
import { RankingContainer } from '@views/Popup/RankingPopup/index.style'
import PopupUtils from '@utils/popup-utils'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import RankingEventButton from '@assets/images/btn/ranking-event-btn.png'
import classNames from 'classnames'
import Login from '@views/Login'

interface RankingPopupButtonProps {
  viewType?: 'home' | 'matchTab' | 'default'
}

const RankingPopupButton = observer(({
                                       viewType = 'default',
                                     }: RankingPopupButtonProps) => {
  const { globalStore, authStore, rankingEventStore } = useRootStore()

  if ((viewType === 'default' && !isMobile)
    || (viewType === 'matchTab' && isMobile)
    || !globalStore.getRankingButtonEnabled()
    || !rankingEventStore.hasRankingButtonEvent) {
    return null
  }

  const containerClass = classNames('', {
    ['home-pc']: viewType === 'home' && !isMobile,
    ['match-tab']: viewType === 'matchTab',
  })

  const buttonClass = classNames('ranking-event-button', {
    ['home-pc']: viewType === 'home' && !isMobile,
    ['match-tab']: viewType === 'matchTab',
  })

  const iconClass = classNames('ranking-event-icon', {
    ['home-pc']: viewType === 'home' && !isMobile,
    ['match-tab']: viewType === 'matchTab',
  })

  return (
    <RankingContainer className={containerClass}>
      <button className={buttonClass} onClick={() => {
        if (!authStore.isSignedIn) {
          authStore.showLoginPopup(<Login/>)
          return
        }

        PopupUtils.showRankingPopup()
      }}>
        <img className={iconClass} src={RankingEventButton} alt="랭킹 이벤트"/>
      </button>
    </RankingContainer>
  )
})

export default RankingPopupButton
